import { memo } from 'react';

export const FunctionCenter = memo(() => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>能力中心</title>
    <defs>
      <radialGradient
        cx="9.69206712%"
        cy="0%"
        fx="9.69206712%"
        fy="0%"
        r="136.148966%"
        gradientTransform="translate(0.096921,0.000000),scale(0.930953,1.000000),rotate(55.795242),translate(-0.096921,-0.000000)"
        id="radialGradient-1"
      >
        <stop stopColor="#7BB0FF" offset="0%"></stop>
        <stop stopColor="#617AFF" offset="100%"></stop>
      </radialGradient>
      <radialGradient
        cx="9.69206712%"
        cy="0%"
        fx="9.69206712%"
        fy="0%"
        r="136.148966%"
        gradientTransform="translate(0.096921,0.000000),scale(0.930953,1.000000),rotate(55.795242),translate(-0.096921,-0.000000)"
        id="radialGradient-2"
      >
        <stop stopColor="#63A1FF" offset="0%"></stop>
        <stop stopColor="#4A67FE" offset="100%"></stop>
      </radialGradient>
      <radialGradient
        cx="25.7248816%"
        cy="27.5789403%"
        fx="25.7248816%"
        fy="27.5789403%"
        r="88.91317%"
        gradientTransform="translate(0.257249,0.275789),scale(1.000000,0.986472),rotate(30.987931),translate(-0.257249,-0.275789)"
        id="radialGradient-3"
      >
        <stop stopColor="#FFFFFF" offset="0%"></stop>
        <stop stopColor="#E0EDFF" offset="100%"></stop>
      </radialGradient>
    </defs>
    <g id="UI稿" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="首页-交互细节"
        transform="translate(-839.000000, -355.000000)"
        fillRule="nonzero"
      >
        <g
          id="nav/选中状态备份-3"
          transform="translate(827.000000, 345.000000)"
        >
          <g id="nav/工作台-s" transform="translate(12.000000, 10.000000)">
            <path
              d="M18.4797518,17.6131917 C16.6494565,19.6459405 11.3691948,17.8754123 6.68595724,13.6586062 C2.00271964,9.44180017 -0.310047066,4.37553491 1.52024821,2.34278607 C3.35054349,0.310037231 8.63080517,2.08056544 13.3140428,6.29737151 C17.9972804,10.5141776 20.3100471,15.5804428 18.4797518,17.6131917 Z"
              id="形状结合"
              fill="url(#radialGradient-1)"
              opacity="0.656511579"
            ></path>
            <path
              d="M18.4797518,2.34278607 C20.3100471,4.37553491 17.9972804,9.44180017 13.3140428,13.6586062 C8.63080517,17.8754123 3.35054349,19.6459405 1.52024821,17.6131917 C-0.310047066,15.5804428 2.00271964,10.5141776 6.68595724,6.29737151 C11.3691948,2.08056544 16.6494565,0.310037231 18.4797518,2.34278607 Z"
              id="形状结合"
              fill="url(#radialGradient-2)"
              opacity="0.746837798"
            ></path>
            <path
              d="M10.0274395,7.21001335 C10.8048089,7.21001335 11.5054903,7.54285685 11.9983661,8.0756284 C12.4514635,8.56540177 12.7289445,9.2241344 12.7289445,9.94856492 C12.7289445,11.4610252 11.5194395,12.6871165 10.0274395,12.6871165 C8.53543948,12.6871165 7.32593448,11.4610252 7.32593448,9.94856492 C7.32593448,8.43610465 8.53543948,7.21001335 10.0274395,7.21001335 Z"
              id="椭圆形备份-25"
              fill="url(#radialGradient-3)"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
));
